'use strict';

var React = require('react');
var styled = require('styled-components');
var component = require('../Icon/component.js');
require('../Tooltip/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

/**
 * TAG CONSTANTS
 */
const tagVariants = {
    default: 'blue',
    blue: 'blue',
    green: 'green',
    grey: 'grey',
    orange: 'orange',
    purple: 'purple',
    red: 'red',
    yellow: 'yellow',
};
/**
 * MAPPING
 */
const textColorMapping = (theme) => ({
    [tagVariants.blue]: theme.designTokens.tagDefaultTextColor,
    [tagVariants.green]: theme.designTokens.tagGreenTextColor,
    [tagVariants.grey]: theme.designTokens.tagGreyTextColor,
    [tagVariants.orange]: theme.designTokens.tagOrangeTextColor,
    [tagVariants.purple]: theme.designTokens.tagPurpleTextColor,
    [tagVariants.red]: theme.designTokens.tagRedTextColor,
    [tagVariants.yellow]: theme.designTokens.tagYellowTextColor,
    disabled: theme.designTokens.tagDisabledTextColor,
});
const backgroundColorMapping = (theme) => ({
    [tagVariants.blue]: theme.designTokens.tagDefaultBackgroundColor,
    [tagVariants.green]: theme.designTokens.tagGreenBackgroundColor,
    [tagVariants.grey]: theme.designTokens.tagGreyBackgroundColor,
    [tagVariants.orange]: theme.designTokens.tagOrangeBackgroundColor,
    [tagVariants.purple]: theme.designTokens.tagPurpleBackgroundColor,
    [tagVariants.red]: theme.designTokens.tagRedBackgroundColor,
    [tagVariants.yellow]: theme.designTokens.tagYellowBackgroundColor,
    removable: theme.designTokens.tagRemovableBackgroundColor,
    disabled: theme.designTokens.tagDisabledBackgroundColor,
});
/**
 * CSS FUNCTIONS
 */
const getTextColor = ({ theme, disabled, variant = tagVariants.default }) => disabled ? textColorMapping(theme).disabled : textColorMapping(theme)[variant];
const getBackgroundColor = ({ theme, disabled, variant = tagVariants.default, }) => disabled ? backgroundColorMapping(theme).disabled : backgroundColorMapping(theme)[variant];
/**
 * Stylized Icons for Tag
 */
const StylizedCustomIcon = styled__default.default(component.Icon) `
  font-size: 12px;
  padding: 2px;
`;
/**
 * Tag Component
 */
const Tag = React.forwardRef(({ disabled = false, variant = tagVariants.default, icon, label, ...props }, ref) => (React__default.default.createElement(TagStyled, { ref: ref, disabled: disabled, variant: variant, ...props },
    label && React__default.default.createElement(TagContentStyled, null, label),
    icon && React__default.default.createElement(StylizedCustomIcon, { name: icon }))));
const TagContentStyled = styled__default.default.span `
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const TagStyled = styled__default.default.div `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  position: relative;

  min-height: 24px;
  min-width: 32px;
  max-width: 100%;
  margin: 0;
  padding: 0 0.25rem;

  background-color: ${getBackgroundColor};

  border: none;
  border-radius: ${({ theme }) => theme.designTokens.tagRadius};

  color: ${getTextColor};
  font: inherit;
  font-family: ${({ theme }) => theme.designTokens.tagFontFamily};
  font-size: ${({ theme }) => theme.designTokens.tagFontSize};
  font-weight: ${({ theme }) => theme.designTokens.tagFontWeight};
  line-height: ${({ theme }) => theme.designTokens.tagFontLineHeight};
  text-align: center;
`;

exports.Tag = Tag;
exports.TagContentStyled = TagContentStyled;
exports.TagStyled = TagStyled;
exports.backgroundColorMapping = backgroundColorMapping;
exports.getBackgroundColor = getBackgroundColor;
exports.getTextColor = getTextColor;
exports.tagVariants = tagVariants;
exports.textColorMapping = textColorMapping;
//# sourceMappingURL=component.js.map
